if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.form.querySelector('[name=id]').disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog')

        this.hideErrors = this.dataset.hideErrors === 'true'
      }

      resetSubmitState() {
        this.submitButton.classList.remove('loading')
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden')
        this.submitButton.removeAttribute('aria-disabled')
      }

      async validateStabilizerQuantity(formData) {
        const maxQty = parseInt(this.dataset.stabilizerMaxQuantity || '', 10)
        if (this.dataset.productType !== 'Stabilizers' || !maxQty) return true

        const variantId = formData.get('id')
        const quantity = parseInt(formData.get('quantity') || '1', 10)

        if (quantity > maxQty) {
          this.handleErrorMessage(`You can add a maximum of ${maxQty} units for this product.`)
          return false
        }

        if (!variantId) return true

        try {
          const cartResponse = await fetch(`${routes.cart_url}.js`)
          const cartData = await cartResponse.json()
          const existingItem = cartData.items.find((item) => item.variant_id == variantId)
          const inCart = existingItem ? existingItem.quantity : 0

          if (inCart + quantity > maxQty) {
            this.handleErrorMessage(
              `You can only purchase up to ${maxQty} Stabilizers per order, you already have ${inCart} in your cart.`
            )
            return false
          }
        } catch (error) {
          console.error('Stabilizer quantity validation failed:', error)
        }

        return true
      }

      async onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden'
        )

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        const variantId = formData.get('id')

        if (!(await this.validateStabilizerQuantity(formData))) {
          this.resetSubmitState()
          return
        }
        const regionPrice = formData.get('properties[_productPriceFor_RegionPrice]')
        
        // Check if same variant already exists in cart and update it instead of adding new
        if (variantId && regionPrice) {
          try {
            const cartResponse = await fetch('/cart.js')
            const cartData = await cartResponse.json()
            
            // Find existing line item with same variant ID
            const existingItem = cartData.items.find(item => item.variant_id == variantId)
            
            if (existingItem) {
              // Calculate _isMetafieldPrice in cents (region price * 100)
              const regionPriceNum = parseFloat(regionPrice)
              const _isMetafieldPrice = Math.round(regionPriceNum * 100)
              
              // Start with existing properties to preserve them
              const properties = existingItem.properties ? { ...existingItem.properties } : {}
              
              // Update with new form properties (this will override existing ones)
              for (const [key, value] of formData.entries()) {
                if (key.startsWith('properties[') && key.endsWith(']')) {
                  const propName = key.slice(11, -1) // Extract property name
                  if (value) { // Only set if value is not empty
                    properties[propName] = value
                  }
                }
              }
              
              // Ensure _isMetafieldPrice is set (override with new value)
              properties._isMetafieldPrice = _isMetafieldPrice.toString()
              
              // Update existing line item properties
              const updateConfig = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  id: existingItem.key,
                  properties: properties
                })
              }
              
              if (this.cart) {
                const sections = this.cart.getSectionsToRender().map((section) => section.id)
                updateConfig.body = JSON.stringify({
                  id: existingItem.key,
                  properties: properties,
                  sections: sections,
                  sections_url: window.location.pathname
                })
                this.cart.setActiveElement(document.activeElement)
              }
              
              const updateResponse = await fetch('/cart/change.js', updateConfig)
              const response = await updateResponse.json()
              
              // Handle response similar to add to cart
              const errorDiv = document.querySelector('.all_items_added_error_mesaage')
              if (errorDiv) errorDiv.innerText = ''
              
              if (response.status) {
                if (errorDiv) {
                  errorDiv.innerText += `⚠️ ${response.description}`
                  errorDiv.classList.remove('hidden')
                }
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                })
                this.handleErrorMessage(response.description)
                this.error = true
                return
              }
              
              if (!this.error && errorDiv) errorDiv.classList.add('hidden')
              
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              })
              this.error = false
              
              const quickAddModal = this.closest('quick-add-modal')
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response)
                    })
                  },
                  { once: true }
                )
                quickAddModal.hide(true)
              } else {
                this.cart.renderContents(response)
              }
              
              let checkAvaibility = document.querySelector('.product-cart-amc.selected')
              if (checkAvaibility) {
                document.querySelectorAll('#CartDrawer-Checkout').forEach(item => item.setAttribute('disabled', 'true'))
                customATCFunction(checkAvaibility.getAttribute('variant-id'))
              }
              
              // Cleanup
              this.submitButton.classList.remove('loading')
              if (this.cart && this.cart.classList.contains('is-empty'))
                this.cart.classList.remove('is-empty')
              if (!this.error) this.submitButton.removeAttribute('aria-disabled')
              this.querySelector('.loading-overlay__spinner').classList.add('hidden')
              const gstValue = sessionStorage.getItem("customer_gst_value")
              if (gstValue) {
                const GSTinputElements = document.querySelectorAll('.customer_gst_value_input')
                GSTinputElements.forEach((element) => {
                  element.value = gstValue.trim()
                })
              }
              return
            }
          } catch (error) {
            console.error('Error checking/updating cart:', error)
            // Fall through to normal add to cart flow
          }
        }
        
        // Normal add to cart flow
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData
        const errorDiv = document.querySelector(
          '.all_items_added_error_mesaage'
        )

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
          if(errorDiv)  errorDiv.innerText = ''
            if (response.status) {
              if(errorDiv){
                errorDiv.innerText += `⚠️ ${response.description}`
                errorDiv.classList.remove('hidden')
              }
              
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              })
              this.handleErrorMessage(response.description)

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message')
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButton.querySelector('span').classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            if (!this.error && errorDiv) errorDiv.classList.add('hidden')

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            })
            this.error = false
            const quickAddModal = this.closest('quick-add-modal')
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response)
                  })
                },
                { once: true }
              )
              quickAddModal.hide(true)
            } else {
              this.cart.renderContents(response)
            }
            let checkAvaibility = document.querySelector('.product-cart-amc.selected');
            if(checkAvaibility){
              document.querySelectorAll('#CartDrawer-Checkout').forEach(item=> item.setAttribute('disabled', 'true'))
              customATCFunction(checkAvaibility.getAttribute('variant-id'));
            }
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            this.submitButton.classList.remove('loading')
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty')
            if (!this.error) this.submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden'
            )
            const gstValue = sessionStorage.getItem("customer_gst_value")
            if(gstValue){
                const GSTinputElements = document.querySelectorAll('.customer_gst_value_input');
                GSTinputElements.forEach((element)=>{
                    element.value = gstValue.trim()
                  
                })
    
            }
          })
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    }
  )
}
